import { IClassname } from '@/lib/shared/model/classname';

export const WashingMachine = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.90137 27.8203V4.17888C2.90137 2.76733 4.04565 1.62305 5.4572 1.62305H26.5428C27.9544 1.62305 29.0987 2.76733 29.0987 4.17888V27.8203C29.0987 29.2319 27.9544 30.3762 26.5428 30.3762H5.4572C4.04565 30.3762 2.90137 29.2319 2.90137 27.8203Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.73511 5.45703H10.5689"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.90137 9.29102H29.0987"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.61035 19.8339C9.61035 20.673 9.77562 21.5039 10.0967 22.2791C10.4178 23.0543 10.8885 23.7587 11.4818 24.352C12.0751 24.9454 12.7795 25.416 13.5547 25.7371C14.33 26.0582 15.1608 26.2235 15.9999 26.2235C16.839 26.2235 17.6699 26.0582 18.4451 25.7371C19.2203 25.416 19.9247 24.9454 20.5181 24.352C21.1114 23.7587 21.582 23.0543 21.9031 22.2791C22.2242 21.5039 22.3895 20.673 22.3895 19.8339C22.3895 18.9948 22.2242 18.164 21.9031 17.3887C21.582 16.6135 21.1114 15.9091 20.5181 15.3158C19.9247 14.7225 19.2203 14.2518 18.4451 13.9307C17.6699 13.6096 16.839 13.4443 15.9999 13.4443C15.1608 13.4443 14.33 13.6096 13.5547 13.9307C12.7795 14.2518 12.0751 14.7225 11.4818 15.3158C10.8885 15.9091 10.4178 16.6135 10.0967 17.3887C9.77562 18.164 9.61035 18.9948 9.61035 19.8339Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.65039 20.2766C10.5855 19.4591 11.792 19.0114 13.0395 19.0186C15.1578 19.0186 18.9706 22.5594 22.3597 19.2048"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.278 5.77665C17.1015 5.77665 16.9585 5.63362 16.9585 5.45717C16.9585 5.28073 17.1015 5.1377 17.278 5.1377"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2778 5.77665C17.4543 5.77665 17.5973 5.63362 17.5973 5.45717C17.5973 5.28073 17.4543 5.1377 17.2778 5.1377"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0285 5.77665C22.852 5.77665 22.709 5.63362 22.709 5.45717C22.709 5.28073 22.852 5.1377 23.0285 5.1377"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0286 5.77665C23.205 5.77665 23.348 5.63362 23.348 5.45717C23.348 5.28073 23.205 5.1377 23.0286 5.1377"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
